angular.module('elfium').service('elfiumLoginService', ['$q', 'elfiumRestService', 'ELFIUM_USER_TYPES',
    function ($q, elfiumRestService, ELFIUM_USER_TYPES) {
        var that = this;
        that._loggedInUser = null;
        that.isUserLoggedIn = function () {
        	return !angular.equals(that._loggedInUser, {});
        };
        that.isUserAdmin = function () {
            return that.isUserLoggedIn() && that._loggedInUser.type == ELFIUM_USER_TYPES.ADMIN;
        };
        that.checkUserLogin = function () {
            var deferred = $q.defer();
            if (that.isUserLoggedIn()) {
                deferred.resolve();
            } else {
                that._getSessionLoginAndTryAgain(deferred);
            }
            return deferred.promise;
        };
        that._getSessionLoginAndTryAgain = function (deferred) {
            that.getSessionLogin().then(function () {
                if (that.isUserLoggedIn()) {
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            }, deferred.reject);
        };
        that.getUserName = function () {
        	return that._loggedInUser.name;
        };
        that.getUserId = function () {
            return that._loggedInUser.id;
        };
        that.getUserPageAccess = function () {
            return that._loggedInUser.pageAccess;
        }
        that.getSessionLogin = function () {
            var deferred = $q.defer();
            elfiumRestService.getSessionLogin().then(function (sessionLoginData) {
                that._fillLoggedInUser(sessionLoginData);
                deferred.resolve();
            }, deferred.reject);
            return deferred.promise;
        };
        that.sendLoginRequest = function (email, password) {
        	var deferred = $q.defer();
        	elfiumRestService.sendLoginRequest(email, password).then(function (loginResult) {
        		that._fillLoggedInUser(loginResult);
        		deferred.resolve('Přihlášení bylo úspěšné!');
        	}, function (errorReason) {
        		that._resetLoggedInUser();
        		deferred.reject(errorReason);
        	});
        	return deferred.promise;
        };
        that.sendRegistrationRequest = function (type, name, nameShort, email, password) {
            var deferred = $q.defer();
            elfiumRestService.sendRegistrationRequest(type, name, nameShort, email, password).then(function () {
                deferred.resolve('Registrace byla úspěšná!');
            }, deferred.reject);
            return deferred.promise;
        };
        that.sendLogoutRequest = function () {
            var deferred = $q.defer();
            elfiumRestService.sendLogoutRequest().then(function () {
                that._resetLoggedInUser();
                deferred.resolve('Odhlášení bylo úspěšné!');
            }, deferred.reject);
            return deferred.promise;
        };
        that._fillLoggedInUser = function (loginResult) {
            if (loginResult.user) {
                that._loggedInUser = loginResult.user;
                elfiumRestService.setToken(loginResult.token);
            }
        };
        that._resetLoggedInUser = function () {
        	that._loggedInUser = {};
            elfiumRestService.resetToken();
        };
        that._resetLoggedInUser();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumLoginService.ts